import { createTransaction } from '../util/api';

// ================ Action types ================ //
export const CREATE_TRANSACTION_REQUEST = 'app/midtrans/CREATE_TRANSACTION_REQUEST';
export const CREATE_TRANSACTION_SUCCESS = 'app/midtrans/CREATE_TRANSACTION_SUCCESS';
export const CREATE_TRANSACTION_ERROR = 'app/midtrans/CREATE_TRANSACTION_ERROR';

// ================ Reducer ================ //
const initialState = {
  transactionInProgress: false,
  transactionData: null,
  transactionError: null,
};

export default function midtransReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case CREATE_TRANSACTION_REQUEST:
      return { ...state, transactionInProgress: true };
    case CREATE_TRANSACTION_SUCCESS:
      return { ...state, transactionInProgress: false, transactionData: payload };
    case CREATE_TRANSACTION_ERROR:
      return { ...state, transactionInProgress: false, transactionError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //
export const createTransactionRequest = () => ({ type: CREATE_TRANSACTION_REQUEST });
export const createTransactionSuccess = payload => ({ type: CREATE_TRANSACTION_SUCCESS, payload });
export const createTransactionError = payload => ({ type: CREATE_TRANSACTION_ERROR, payload });

// ================ Thunks ================ //
export const initiateMidtransPayment = ({ orderId, buyerId, amount }) => async dispatch => {
  dispatch(createTransactionRequest());
  try {
    const res = await createTransaction({ orderId, buyerId, amount });
    dispatch(createTransactionSuccess(res.data.data));
    return res.data.data;
  } catch (error) {
    dispatch(createTransactionError(error));
    throw error;
  }
};
